"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rtlLanguages = exports.CetComponentsProvider = exports.CetComponentsContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultValues = {
  fontFamily: 'AlmoniNeue',
  basicFontSize: '16',
  siteKey: '',
  siteName: '',
  hostKey: '',
  language: 'he',
  rootFontSize: 10,
  isUpdateFontSizeOnResizeEnabled: true,
  mobileBreakpoint: 768,
  themeColors: {
    general: {
      light: '#ffffff',
      text: '#383745',
      subText: '#6d6d6d',
      border: '#e0e0e0',
      success: '#02C971',
      alert: '#D6434D'
    },
    basic: {
      main: '#ececf0',
      dark: '#64636d',
      light: '#f7f7f9',
      shadow: '#d0d0d0',
      start: '#ececf0',
      end: '#d0d0d0'
    },
    primary: {
      main: '#5750fa',
      dark: '#6C68BA',
      light: '#ECEBFF',
      shadow: 'rgba(87, 80, 250, 0.2)',
      start: '#5750fa',
      end: '#1e5afe',
      shade1: '#E2E2F7',
      shade2: '#DDDCFE',
      shade3: '#C1BFEF',
      shade4: '#9793FA',
      shade5: '#7771FA'
    }
  },
  direction: 'rtl',
  opDirection: 'ltr'
};
var rtlLanguages = ['he', 'ar'];
exports.rtlLanguages = rtlLanguages;
var CetComponentsContext = /*#__PURE__*/_react.default.createContext(defaultValues);
exports.CetComponentsContext = CetComponentsContext;
var CetComponentsProvider = function CetComponentsProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(value),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(value, true),
    isMobileView = _useDeviceData.isMobileView;
  var contextValue = _objectSpread({}, defaultValues);
  contextValue.fontFamily = value.language === 'ar' ? 'abraham' : 'AlmoniNeue';
  contextValue.basicFontSize = isMobileView ? pxToRem(18) : pxToRem(16);
  contextValue = _objectSpread(_objectSpread({}, contextValue), value);
  contextValue.direction = rtlLanguages.includes(contextValue.language) ? 'rtl' : 'ltr';
  contextValue.opDirection = rtlLanguages.includes(contextValue.language) ? 'ltr' : 'rtl';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CetComponentsContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.CetComponentsProvider = CetComponentsProvider;